import {Component, Input, OnInit} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {Location} from '@angular/common';
import {FlashMessagesService} from 'angular2-flash-messages';
import {Utils} from '../shared/utils';

import {CadastroComponent} from "../cadastro/cadastro.component";

import { RecuperarSenhaService } from './recuperar-senha.service';
declare var jQuery: any;


@Component({
    selector: 'app-recuperar-senha',
    templateUrl: './recuperar-senha.component.html',
    styleUrls: ['./recuperar-senha.component.css'],
    providers:[
      RecuperarSenhaService
    ]
})
export class RecuperarSenhaComponent implements OnInit {

    cpf: string;
    public cpf_mask = [/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];

    constructor(private router: Router,
                private recSenhaService: RecuperarSenhaService,
                private flashMessagesService: FlashMessagesService,
				private utils: Utils) {

    }

    onSubmit() {
      this.recSenhaService.solicitarRecuperacao({'cpf': this.cpf}).subscribe(
        response => {

          let msgColor = 'success';

          if(response.error){
            msgColor = 'danger';
          }

			this.utils.exibirMensagem(response.msg, msgColor);

          if(!response.error){
            this.redirectToLogin();
          }

      }, error => { 
	    if (error.status != 500)
			this.utils.exibirMensagem(error, 'danger');
      });
    }

    maskcpf(field_id){
        let text = jQuery('#'+field_id).val();
        text=text.replace(/\D/g,""); //remove caracteres que não sejam números.

        //Aplica Mascara
        text=text.replace(/(\d{3})(\d)/,"$1.$2");   //Coloca ponto entre o terceiro e o quarto dígitos
        text=text.replace(/(\d{3})(\d)/,"$1.$2");   //Coloca ponto entre o setimo e o oitava dígitos
        text=text.replace(/(\d{3})(\d)/,"$1-$2");   //Coloca ponto entre o decimoprimeiro e o decimosegundo dígitos
        text=text.substr(0,14);
        jQuery('#'+field_id).val(text);
        this.cpf=text;
        this.testaCPF();


    }

    testaCPF() {
        let Soma;
        let Resto;
        Soma = 0;
        let strCPF = jQuery('#CPF').val();
        strCPF = strCPF.replace(/\D/g, '');
        // console.log(strCPF);
        if (strCPF === '00000000000') {
            this.utils.exibirMensagem('CPF Invalido', 'danger');
            return false;
        };

        for (let i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
        Resto = (Soma * 10) % 11;
        if ((Resto === 10) || (Resto === 11)) Resto = 0;
        if (Resto !== parseInt(strCPF.substring(9, 10))) {
            this.utils.exibirMensagem('CPF Invalido', 'danger');
            return false;
        }
        Soma = 0;
        for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
        Resto = (Soma * 10) % 11;
        if ((Resto === 10) || (Resto === 11)) Resto = 0;

        if (Resto !== parseInt(strCPF.substring(10, 11))) {
            this.utils.exibirMensagem('CPF Invalido', 'danger');
            return false;
        }

        return true;
    }


    ngOnInit() {
    }

    redirectToLogin(){
      this.router.navigateByUrl('acesso');
    }

}



// WEBPACK FOOTER //
// ./src/app/recuperar-senha/recuperar-senha.component.ts